import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpGetMyCompany } from "~/services/http/companies";

/** Profile completeness for stored company (not Stripe — see services/companies.js). */
function companyStoredProfileValid(company) {
  if (!company) {
    return false;
  }
  if (!company?.name || company?.name.length == 0) {
    return false;
  }
  if (!company?.business_id || company?.business_id.length == 0) {
    return false;
  }
  if (
    !company?.main_city ||
    !company?.main_city?.id ||
    company?.main_city?.id < 0
  ) {
    return false;
  }
  if (company?.checked == false) {
    return false;
  }
  return true;
}

export const fetchMyCompanyAsync = createAsyncThunk(
  "companies/fetchMyCompany",
  async (_, { rejectWithValue }) => {
    try {
      return await httpGetMyCompany();
    } catch (error) {
      return rejectWithValue({
        statusCode: error.status,
      });
    }
  },
);

const companiesSlice = createSlice({
  name: "companies",
  initialState: { data: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMyCompanyAsync.fulfilled, (state, action) => {
      const data = action.payload;
      state.data.me = {
        ...data,
        valid: companyStoredProfileValid(data),
      };
    });
  },
});

export const getMyCompany = () => (dispatch) =>
  dispatch(fetchMyCompanyAsync()).unwrap();

export default companiesSlice.reducer;
